import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DryCleaningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dry_cleaning"}/>
}
